module.exports = __webpack_public_path__ + "img/print-logo.5dc80508.png";